import React, { PropTypes } from 'react';
import { FieldArray, reduxForm, SubmissionError } from 'redux-form';
import { Button, Row, Col } from 'react-bootstrap';
import axios from './../../../constants/axios';
import alert from 'alertify.js';
import selectOptionFormatter from './../../../selectors/selectOptionFormatter';

import RenderAccount from './Helper/RenderAccount';

class NewJournalEntryForm extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         chartOfAccounts: []
      };
   }

   componentDidMount() {
      axios.get('accounting/chartOfAccounts')
         .then((res) => {
            this.setState({
               chartOfAccounts: selectOptionFormatter(res.data)
            });
         });
   }

   save = (inputs) => {
      return axios.post('accounting/journalEntries', inputs)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Entry Created.');
               this.context.router.push('/journalEntry');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { error, handleSubmit, submitting, invalid } = this.props;
      const { chartOfAccounts } = this.state;
      return (
         <form noValidate autoComplete="off" onSubmit={handleSubmit(this.save)} className="form-inline" >
            <Row>
               <Col md={6} >
                  <h4>Debit Entries</h4>
                  <FieldArray name="debits" component={RenderAccount} chartOfAccounts={chartOfAccounts} />
               </Col>
               <Col md={6} >
                  <h4>Credit Entries</h4>
                  <FieldArray name="credits" component={RenderAccount} chartOfAccounts={chartOfAccounts} />
               </Col>
            </Row>
            <hr/>
            {error && <strong className="input-validation-error" >{error}</strong>}
            <Button type="submit" bsStyle="success" block disabled={submitting || invalid} >Save</Button>
         </form>
      );
   }
}

NewJournalEntryForm.propTypes = {
   error: PropTypes.object,
   handleSubmit: PropTypes.func,
   submitting: PropTypes.bool,
   invalid: PropTypes.bool
};

NewJournalEntryForm.contextTypes = {
   router: PropTypes.object
};

export default reduxForm({
   form: 'newJournalEntry'
})(NewJournalEntryForm);



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/JournalEntries/NewJournalEntryForm.js
 **/